// Arithmetic helpers applied after local function references are resolved.
// Example: `font-size: 12px * 2;` becomes `font-size: 24px;`.
import { evaluateMultiplicationExpressions } from '../../loops/for-loop/arithmetic'
import { evaluatePlainAddSubExpressions } from '../../loops/for-loop/plain-addition'

// Resolve lightweight arithmetic inside expanded function bodies.
export function resolveFunctionMathExpressions(source: string): string {
  let output = source
  // Check whether the function body contains plain add/sub chains.
  if (output.includes(' + ') || output.includes(' - ')) {
    output = evaluatePlainAddSubExpressions(output, {})
  }
  // Check whether the function body contains multiplication expressions.
  if (output.includes('*')) {
    output = evaluateMultiplicationExpressions(output, {})
  }
  // Return the function body after lightweight arithmetic resolution.
  return output
}
